import {EditorServiceRequestTask} from '@megaphonenpm/mputils/src/serviceio/EditorServiceRequestTask.js';
import {GET} from '@megaphonenpm/mputils/src/constants.js';

/**
 * Retrieves the ThemeSets specified by themesetIDs from Editor Service.
 */
export class GetEditorThemeSetsTask extends EditorServiceRequestTask {
  constructor (themesetIDs = [], env, studioSessionToken) {
    super('GET_EDITOR_THEMESETS', GET, env, studioSessionToken);
    this.themesetIDs = themesetIDs;
    this.themesets = null;
  }

  getPath () {
    let querystring = '';
    if (this.themesetIDs.length > 0) {
      querystring = '?ids[]=' + this.themesetIDs.join('&ids[]=');
    }

    return `/theme_sets/${querystring}`;
  }

  onSuccess (data) {
    this.themesets = data;
  }
}


